import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-gap: ${tokens.space.large};
`;
